import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import { coachRoles, customText, hasModule, isCoach } from 'helpers/profile';
import { SystemText } from 'e4shared';
import { getPermissions } from 'helpers/permissions';

export const Person = props => {
    const { data, user, coaching, downline, history } = props;

    const [permissions, setPermissions] = React.useState(getPermissions());

    const isManager = user.id === data.id || downline?.find(d => d.id === data.id);
    const isAdministrator = user.administrator;

    const goTo = (event, link) => {
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        history.push(link);
    };

    React.useEffect(() => {
        if (data?.id && user?.id) {
            setPermissions(getPermissions(data, user, coaching, downline));
        }
    }, [data?.id, user?.id]);

    const st = (s, x) => SystemText(`Search/Results/Person/${s}`, x);

    return (
        <div className="search-result box" style={{ cursor: 'default' }}>
            <div className="image-holder hidden-xs">
                <BlobImage folder="avatar" initials={data.initials} src={data.image} width="75" height="75" />
            </div>
            <div>
                <label className="label label-primary">
                    <i className="mr10 fa fa-user" />
                    {st('Title')}
                </label>
                <h2>{data.name}</h2>
                {data.summary && (
                    <div className="mb2">
                        {st('Manager')}:{' '}
                        <Link to={`/search/${data.summary}`}>
                            <BlobImage
                                folder="avatar"
                                initials={data.initials}
                                src={data.extras5}
                                className="mr5 ml5"
                                width="20"
                                height="20"
                            />
                            {data.summary}
                        </Link>
                    </div>
                )}
                {data.extras1 && <span>{data.extras1}</span>}
                {data.extras2 && (
                    <span>
                        {st('Department')} : {data.extras2}
                    </span>
                )}
                {data.extras3 && (
                    <span>
                        {st('Location')} : {data.extras3}
                    </span>
                )}
                <div className="table-btns mt5">
                    {hasModule(user, 'blogs') && (
                        <button onClick={event => goTo(event, `/blog/${data.id}`)} className="btn btn-default btn-xs">
                            {st('Blog')}
                        </button>
                    )}
                    {hasModule(user, 'objectives') && permissions.objectives.canView && (
                        <button onClick={event => goTo(event, `/objectives/${data.id}`)} className="btn btn-default btn-xs">
                            {st('Objectives')}
                        </button>
                    )}
                    {permissions.one2ones.canView && (
                        <button
                            onClick={event => goTo(event, `/develop/performance-dashboard/${data.id}`)}
                            className="btn btn-default btn-xs"
                        >
                            {st('121s')}
                        </button>
                    )}
                    {permissions.reviews.canView && (
                        <button
                            onClick={event => goTo(event, `/develop/reviews/${data.id}`)}
                            className="btn btn-default btn-xs"
                        >
                            {st('Reviews')}
                        </button>
                    )}
                    {hasModule(user, 'pathways') && permissions.pathways.canView && (
                        <button
                            onClick={event => goTo(event, `/develop/pathways/${data.id}`)}
                            className="btn btn-default btn-xs"
                        >
                            {st('Pathways')}
                        </button>
                    )}
                    {data.extras6 > 0 && (isManager || isAdministrator) && (
                        <button
                            onClick={event => goTo(event, `/search?manager=${data.id}&name=${data.name}`)}
                            className="btn btn-default btn-xs"
                        >
                            {st('Team')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default withRouter(Person);
